<template>
  <div id="app">
    <medfilm-header :authenticated="authenticated"></medfilm-header>
    <medfilm-menu :authenticated="authenticated"></medfilm-menu>
    <div class="wrap">
      <div class="container">
        <router-view :authenticated="authenticated"></router-view>
      </div>
    </div>
    <loader :loaderActive="loaderActive"></loader>
    <div id="auth"></div>
  </div>
</template>

<script>
  import loader from './frame/loader.vue'
  import medfilmHeader from './frame/header.vue'
  import medfilmMenu from './frame/menu.vue'
  import auth from '~/lib/auth'

  export default {
    name: 'app',
    data () {
      return {
        loaderActive: true,
        authenticated: false
      }
    },
    mounted () {
      let that = this

      that.loaderActive = false
      that.authenticated = auth.authenticated
    },
    created () {
      let that = this

      // If the user was forcefully logout, update this variable
      auth.$on('force-logout', function () {
        that.$router.go('/login')
        that.authenticated = false
        window.location.reload()
      })

      // Update variable on successful login
      auth.$on('login-successful', function () {
        that.authenticated = true
      })
    },
    components: {
      loader,
      medfilmHeader,
      medfilmMenu
    }
  }
</script>

<style rel="stylesheet/scss" type="text/css" lang="scss">
  @import "./../scss/standard-colours";
  @import "./../scss/buttons";
  @import "./../scss/view-standard-classes";
  @import "./../scss/calendar-custom.scss";

  @font-face {
    font-family: 'Century Gothic';
    src: url('../assets/fonts/century_gothic.eot'); /* IE9 Compat Modes */
    src: url('../assets/fonts/century_gothic.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('../assets/fonts/century_gothic.woff2') format('woff2'), /* Super Modern Browsers */
    url('../assets/fonts/century_gothic.woff') format('woff'), /* Pretty Modern Browsers */
    url('../assets/fonts/century_gothic.ttf')  format('truetype'), /* Safari, Android, iOS */
    url('../assets/fonts/century_gothic.svg#svgFontName') format('svg'); /* Legacy iOS */
  }

  @font-face {
    font-family: 'Open Sans';
    src:
      url('../assets/fonts/open-sans/OpenSans-Regular.ttf') format('truetype'),
      url('../assets/fonts/open-sans/OpenSans-Regular.eot?#iefix') format('embedded-opentype'),
      url('../assets/fonts/open-sans/OpenSans-Regular.woff') format('woff'),
      url('../assets/fonts/open-sans/OpenSans-Regular.svg#OpenSans') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Open Sans';
    src: url('../assets/fonts/open-sans/OpenSans-Bold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Open Sans';
    src: url('../assets/fonts/open-sans/OpenSans-Italic.ttf') format('truetype');
    font-weight: normal;
    font-style: italic;
  }

  @font-face {
    font-family: 'Open Sans';
    src: url('../assets/fonts/open-sans/OpenSans-Light.ttf') format('truetype');
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: 'Open Sans';
    src: url('../assets/fonts/open-sans/OpenSans-ExtraBold.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
  }

  @font-face {
    font-family: 'Open Sans';
    src: url('../assets/fonts/open-sans/OpenSans-BoldItalic.ttf') format('truetype');
    font-weight: bold;
    font-style: italic;
  }

  @font-face {
    font-family: 'Open Sans';
    src: url('../assets/fonts/open-sans/OpenSans-ExtraBoldItalic.ttf') format('truetype');
    font-weight: 900;
    font-style: italic;
  }

  * {
    padding: 0;
    margin: 0;
    font-family: 'Open Sans', 'Century Gothic', sans-serif;
  }

  html, body {
    background: #ffffff;
    position: relative;
  }

  html {
    overflow-y: scroll;
  }

  #app {
    overflow: hidden;
    min-width: 1400px;
  }

  .hidden {
    display: none;
  }

  .wrap {
    text-align: center;
  }

  .container {
    width: 1400px;
    display: inline-block;
    text-align: left;
    height: 100%;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// app.vue?23e3cce2